"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_1 = require("web3x/contract");

var SignatureValidatorAbi_1 = __importDefault(require("./SignatureValidatorAbi"));

var SignatureValidator = /*#__PURE__*/function (_contract_1$Contract) {
  _inherits(SignatureValidator, _contract_1$Contract);

  function SignatureValidator(eth, address, options) {
    _classCallCheck(this, SignatureValidator);

    return _possibleConstructorReturn(this, _getPrototypeOf(SignatureValidator).call(this, eth, SignatureValidatorAbi_1.default, address, options));
  }

  return SignatureValidator;
}(contract_1.Contract);

exports.SignatureValidator = SignatureValidator;
exports.SignatureValidatorAbi = SignatureValidatorAbi_1.default;